import buildRestProvider from "../shared/utilities/simpleRestProvider"

import {
  CreateParams,
  UpdateParams,
  DataProvider,
  fetchUtils,
} from "react-admin";
import { LaboratoryRegistry } from "../shared/types/types";

const fetchJson = (url, options: any = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  // add your own headers here
  options.headers.set("X-Correlation-Id", "foobar");
  options.headers.set("X-App-Id", "00e9396e-6c63-4834-8492-a1db4edc6421");
  options.headers.set(
    "Authorization",
    `Bearer ${localStorage.getItem("auth")?.toString()}`
  );
  return fetchUtils.fetchJson(url, options).catch(error => {
    // Extraer el mensaje del objeto ResponseError del backend
    if (error.body && error.body.message) {
      error.message = error.body.message;
    }
    throw error;
  });
};

const baseDataProvider = buildRestProvider(
  String(process.env.REACT_APP_API_URL),
  fetchJson
);

const createPostFormData = async (
  params:
    | CreateParams<LaboratoryRegistry>
    | UpdateParams<LaboratoryRegistry>
) => {
  const formData = new FormData();

  const laboratoryRegistry = params.data

  if(laboratoryRegistry.qualityReport?.file) {
    if(laboratoryRegistry.qualityReport.file.rawFile) {
      // Archivo nuevo seleccionado por el usuario: se sube directamente
      formData.append("qualityReportFile", laboratoryRegistry.qualityReport.file.rawFile);
    }
    // Si el archivo ya existe en el servidor (sin rawFile), NO se re-descarga.
    // El backend mantiene el archivo existente mediante el ID en el JSON.
  }

  formData.append(
    "laboratoryRegistryInfo",
    new Blob([JSON.stringify(laboratoryRegistry)], {
      type: "application/json",
    })
  );
  return formData;
};

export const dataProvider: DataProvider = {
  ...baseDataProvider,
  create: async (resource, params) => {
    if (resource === "laboratoryRegistry") {
      const formData = await createPostFormData(params);
      return fetchJson(`${process.env.REACT_APP_API_URL}/${resource}`, {
        method: "POST",
        body: formData,
      }).then(({ json }) => ({ data: json }));
    }

    return baseDataProvider.create(resource, params);
  },
  update: async (resource, params) => {
    if (resource === "laboratoryRegistry") {
      const formData = await createPostFormData(params);
      return fetchJson(`${process.env.REACT_APP_API_URL}/${resource}/${params.id}`, {
          method: "PUT",
          body: formData,
        })
        .then(({ json }) => ({ data: json }));
    }

    return baseDataProvider.update(resource, params);
  },
};
